import { Credentials } from "../../models/credentials.model";
import { authService } from "../../services/auth.service";
import store from "@/store/store";
import { setting } from "@/common/settings";


// tslint:disable-next-line:typedef
const state = {
    token: localStorage.getItem("auth-token") || "",
    refreshToken: localStorage.getItem("refresh-token") || "",
    companyId: localStorage.getItem("companyId") || "",
    managementId: localStorage.getItem("managementId") || "",
    userName: localStorage.getItem("userName") || "",
    cardPinBoardLocking: localStorage.getItem("cardPinBoardLocking") || "",
    roles: localStorage.getItem("roles") || "",
    status: "",
    isRefreshing: false as boolean,
    refreshingCall: undefined as any,
};

// tslint:disable-next-line:typedef
const getters = {
    isAuthenticated: (authState: any) => !!authState.token,
    roles: (authState: any) => authState.roles,
    authStatus: (authState: any) => authState.status,
    authToken: (authState: any) => authState.token,
    refreshToken: (authState: any) => authState.refreshToken,
    companyId: (authState: any) => authState.companyId,
    managementId: (authState: any) => authState.managementId,
    userName: (authState: any) => authState.userName,
    cardPinBoardLocking: (authState: any) => authState.cardPinBoardLocking,
    isAdmin: (authState: any) => {
        return authState.roles.includes("admin");
    },
    isRefreshing: (authState: any) => authState.isRefreshing,
    refreshingCall: (authState: any) => authState.refreshingCall,
    hasManagement: (authState: any) => authState.managementId != null && authState.managementId != "" && authState.managementId != "null" ? true : false,
};

// tslint:disable-next-line:typedef
const actions = {
    authRequest: ({ commit, dispatch, getters }: { commit: any, dispatch: any, getters: any }, credentials: Credentials) => {
        return new Promise((resolve, reject) => {
            commit("authRequest");
            authService.login(credentials)
                .then(async (result: any) => {
                    // console.log(result.data);


                    localStorage.setItem("auth-token", result.data.token); // stash the auth token in localStorage
                    localStorage.setItem("refresh-token", result.data.refreshToken);
                    localStorage.setItem("tokenExpiration", result.data.tokenExpiration);
                    localStorage.setItem("roles", JSON.stringify(result.data.roles));
                    localStorage.setItem("companyId", result.data.companyId);
                    localStorage.setItem("managementId", result.data.managementId);
                    localStorage.setItem("userName", result.data.userName);
                    localStorage.setItem("cardPinBoardLocking", result.data.cardPinBoardLocking);

                    commit("authSuccess", { token: result.data.token, refreshToken: result.data.refreshToken });
                    commit("authSetRoles", result.data.roles);
                    commit("authSetCompanyId", result.data.companyId);
                    commit("authSetManagementId", result.data.managementId);
                    commit("authSetUserName", result.data.userName);
                    commit("authSetCardPinBoardLocking", result.data.cardPinBoardLocking);

                    await store.dispatch("socket/initConnection");
                    // if (getters.hasManagement) {
                    //     await store.dispatch("socket/init", setting.HubUrl.current);
                    //     await store.dispatch("socket/connect");
                    // }

                    resolve(result);
                },
                    (errors: any) => {
                        commit("authError", errors);
                        localStorage.removeItem("auth-token");
                        localStorage.removeItem("roles");
                        localStorage.removeItem("companyId");
                        localStorage.removeItem("managementId");
                        localStorage.removeItem("companyName");
                        localStorage.removeItem("companyImage");
                        localStorage.removeItem("userName");
                        localStorage.removeItem("setting");
                        localStorage.removeItem("cardPinBoardLocking");
                        localStorage.removeItem("cardsOnPinBoard");
                        localStorage.removeItem("jobsOnPinBoard");
                        localStorage.removeItem("pinboards");
                        localStorage.removeItem("tokenExpiration");
                        localStorage.removeItem("refresh-token");
                        localStorage.removeItem("cardUsersOnPinBoard");
                        store.dispatch("card/clearCardState");
                        store.dispatch("app/clearCompanyInfo");
                        reject(errors);
                    });
        });
    },
    authLogout: ({ commit, dispatch }: { commit: any, dispatch: any }) => {
        return new Promise((resolve, reject) => {
            commit("authLogout");
            localStorage.removeItem("auth-token");
            localStorage.removeItem("roles");
            localStorage.removeItem("companyId");
            localStorage.removeItem("managementId");
            localStorage.removeItem("userName");
            localStorage.removeItem("setting");
            localStorage.removeItem("cardPinBoardLocking");
            localStorage.removeItem("cardsOnPinBoard");
            localStorage.removeItem("companyName");
            localStorage.removeItem("companyImage");
            localStorage.removeItem("jobsOnPinBoard");
            localStorage.removeItem("pinboards");
            localStorage.removeItem("tokenExpiration");
            localStorage.removeItem("refresh-token");
            localStorage.removeItem("cardUsersOnPinBoard");
            store.dispatch("card/clearCardState");
            store.dispatch("app/clearCompanyInfo");
            resolve(null);
        });
    },
    refresh: ({ commit, dispatch, getters }: { commit: any, dispatch: any, getters: any }) => {
        commit("mAuthSetIsTokenRefreshing", true);
        return new Promise((resolve, reject) => {
            // console.log("refresh");
            // console.log(getters.refreshToken + " " + getters.authToken);

            // authService.refresh(localStorage.getItem("refresh-token"), localStorage.getItem("auth-token")).then((result: any) => {

            authService.refresh(getters.refreshToken, getters.authToken).then((result: any) => {
                localStorage.setItem("auth-token", result.data.token); // stash the auth token in localStorage
                localStorage.setItem("refresh-token", result.data.refreshToken);
                localStorage.setItem("tokenExpiration", result.data.tokenExpiration);
                commit("authSuccess", { token: result.data.token, refreshToken: result.data.refreshToken });

                resolve(result);
            },
                (errors: any) => {
                    commit("authError", errors);
                    localStorage.removeItem("auth-token");
                    localStorage.removeItem("roles");
                    localStorage.removeItem("companyId");
                    localStorage.removeItem("managementId");
                    localStorage.removeItem("companyImage");
                    localStorage.removeItem("userName");
                    localStorage.removeItem("setting");
                    localStorage.removeItem("cardPinBoardLocking");
                    localStorage.removeItem("cardsOnPinBoard");
                    localStorage.removeItem("companyName");
                    localStorage.removeItem("jobsOnPinBoard");
                    localStorage.removeItem("pinboards");
                    localStorage.removeItem("tokenExpiration");
                    localStorage.removeItem("refresh-token");
                    localStorage.removeItem("cardUsersOnPinBoard");
                    store.dispatch("card/clearCardState");
                    store.dispatch("app/clearCompanyInfo");
                    reject(errors);
                });
        })
    }
};

// tslint:disable-next-line:typedef
const mutations = {
    authRequest: (authState: any) => {
        authState.status = "attempting authentication request";
    },
    mAuthSetIsTokenRefreshing: (authState: any, state: boolean) => {
        authState.isRefreshing = state;
    },
    mSetRefreshingCall: (authState: any, value: any) => {
        authState.refreshingCall = value;
    },
    authSuccess: (authState: any, tokens: any) => {
        authState.status = "authentication succeeded";
        authState.refreshToken = tokens.refreshToken;
        authState.token = tokens.token;
        authState.isRefreshing = false;
        authState.refreshingCall = undefined;

        localStorage.setItem("auth-token", tokens.token); // stash the auth token in localStorage
        localStorage.setItem("refresh-token", tokens.refreshToken);
    },
    authSetCompanyId: (authState: any, key: string) => {
        authState.companyId = key;
    },
    authSetManagementId: (authState: any, key: string) => {
        authState.managementId = key;
    },
    authSetUserName: (authState: any, id: string) => {
        authState.userName = id;
    },
    authSetCardPinBoardLocking: (authState: any, value: boolean) => {
        authState.cardPinBoardLocking = value;
    },
    authSetRoles: (authState: any, roles: string[]) => {
        authState.roles = roles;
    },
    authError: (authState: any) => {
        authState.status = "error";
    },
    authLogout: (authState: any) => {
        authState.token = "";
        authState.refreshToken = "";
        authState.roles = "";
        authState.companyId = "";
        authState.managementId = "";
        authState.userName = "";
        authState.isRefreshing = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};

